import React, { useState, useRef, useEffect } from 'react';

import { Button, Input } from 'reactstrap';
import { useDocViewer } from '../Context';
import { createSignatureImageFromText } from '~/helpers/signatureTextCanvas';

type TDocViewerSignTextProps = {
  field: any;
  closeHandler: () => void;
  isActive: boolean;
}

const DocViewerSignText = (props: TDocViewerSignTextProps) => {

  /**
   * Component props:
   * field {object} the signature field (used only to know which field to update; signature image is canonical and scales at display)
   * closeHandler {func} callback to call in order to dismiss the modal
   * isActive {boolean} TRUE if the typing tab is the active tab
   */
  const { field, closeHandler, isActive } = props;

  /**
   * Ref to the input dom object (for font-family and focus)
   */
  const input: any = useRef(null);

  /**
   * Context vars (see: Context.tsx)
   */
  const { updateField } = useDocViewer();

  /**
   * Stores the text the user has typend into the text box
   */
  const [signature, setSignature] = useState('');

  /**
   * This effect runs whenever the tab is activated/deactivated
   * We use it to auto-focus the input field
   */
  useEffect(() => {
    // abort if the tab has just been deactivated
    if (!isActive) {
      return;
    }
    // focus the input field
    input.current.setSelectionRange(signature.length, signature.length);
    input.current.focus();
  }, [isActive]);

  /**
   * Event handler called when the user clicks the 'Apply' button.
   * Uses a canonical signature image (same size/font for all fields and devices); display and backend scale to each field.
   */
  const applySignature = () => {
    const fontFamily = window.getComputedStyle(input.current).getPropertyValue('font-family');
    const data = createSignatureImageFromText(signature, fontFamily);
    updateField({ ...field, signature: data });
    closeHandler();
  }

  return <React.Fragment>
    <div className="doc-viewer-sign-text">
      <Input innerRef={input} type="text" className="form-control sign-text-field" placeholder="Type here" onChange={e => setSignature(e.target.value)} value={signature} />
    </div>
    <div className="modal-footer">
      <Button type="button" color="primary" onClick={applySignature} data-dismiss="modal" disabled={!signature}>Apply</Button>
      <Button type="button" color="secondary" onClick={closeHandler} data-dismiss="modal">Close</Button>
    </div>
  </React.Fragment>
}

export default DocViewerSignText;